// Components/Validations/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Store } from "../../Store";
import { getStoredUserInfo } from "../../utils/storage";

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  // First check localStorage if userInfo is not in state
  if (!userInfo) {
    const savedUserInfo = getStoredUserInfo();
    if (savedUserInfo) {
      return children;
    }
  }

  return userInfo ? children : <Navigate to="/" />;
}